import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import ResetPasswordForm from './ResetPasswordForm';
import CommonPaper from '../common/CommonPaper';
import CommonContainer, { SIZE_HALF } from '../common/CommonContainer';
import { RESET_PASSWORD_SUCCESS_REDIRECT_URL } from '../..//utils/redirect-const';
import { requestResetPassword } from '../../actions/auth-actions';
import CommonCenterContainer from '../common/CommonCenterContainer';

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const requestResult = useSelector(store => store.api.requestResult);

  React.useEffect(() => {
    if (requestResult && requestResult.success) {
      navigate(RESET_PASSWORD_SUCCESS_REDIRECT_URL);
    }
  }, [requestResult, navigate]);

  return (
    <CommonCenterContainer>
      <CommonContainer size={SIZE_HALF} component={CommonPaper}>
        <Typography paragraph variant="h5">
          Reset hasła
        </Typography>
        <Typography paragraph>
          Podaj swój adres e-mail, a my wyślemy Ci link do zresetowania hasła.
        </Typography>
        <ResetPasswordForm onSubmit={data => dispatch(requestResetPassword(data))} />
      </CommonContainer>
    </CommonCenterContainer>
  );
};

export default ResetPassword;
